import styled, { css } from 'styled-components';

import { forIPad } from '../../utility/styled';

/**
 * Shared styled primitives for the bottom playback-controls bar.
 * Used by
 * - `src/components/stage/Stage.tsx`
 * - `src/components/content-components/ClipPreviewControlBar.tsx`
 */

export const PlayButton = styled.div<{
  disabled?: boolean;
  background?: boolean;
  margin?: number;
}>`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: all 150ms ease-out;

  &:hover {
    background-color: var(--surface-elevated);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const PlayForward = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: var(--radius-button);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 150ms ease-out;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    background-color: var(--surface-elevated);
    svg path {
      fill: var(--foreground);
      stroke: var(--foreground);
    }
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const PlayBackward = styled(PlayForward)`
  transform: rotate(180deg);
`;

export const Time = styled.div<{ curHasHours: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  white-space: nowrap;
  font-size: var(--text-xs);
  align-items: center;
  padding: 0 6px;
  gap: 2px;
  font-variant-numeric: tabular-nums;

  .current {
    opacity: 0.8;
    color: var(--foreground);
    display: inline-flex;
    white-space: nowrap;
    ${({ curHasHours }) => css`
      min-width: ${curHasHours ? '74px' : '56px'};
    `}
  }

  .end {
    opacity: 0.4;
    display: inline-flex;
    justify-content: flex-end;
    white-space: nowrap;
    min-width: 56px;

    ${forIPad(`
      min-width: 48px;
    `)}
  }
`;
